module.exports = __webpack_public_path__ + "img/error-modal-pic.bd7c1c9c.png";